import { PureComponent } from 'react';
import { isNil } from 'lodash';

import { FUEL_LEVEL_VALUES_V2 } from 'constants/fuelLevels.constants';

// COMPONENTS
import ConnectedField from './connectedField';
import { SelectInput } from './selectField';

// HOCS
import withTransforms from './withTransforms';
import withFormikInput from './withFormikInput';
import withFormField from './withFormField';

// UTILS
import { fuel, isNilOrEmpty } from 'utils';

const convertPercentageToIndex = (value) => {
  if (value === '') {
    return value;
  }
  const convertedValue = fuel.convertPercentageToIndex(value);
  return isNil(convertedValue) ? '' : convertedValue;
};

const convertIndexToPercentage = (value) => {
  if (value === '') {
    return value;
  }
  const convertedValue = fuel.convertIndexToPercentage(value);
  return isNil(convertedValue) ? '' : convertedValue;
};

export const FuelSelect = withTransforms(SelectInput, {
  inputTransforms: [convertPercentageToIndex],
  outputTransforms: [convertIndexToPercentage],
});

const config = {
  getValidity: ({ connectedFuelLevel }) => !isNil(connectedFuelLevel),
  getConnectivityStatusText: (meta) => {
    if (isNil(meta.connectedFuelLevel)) {
      return { translationId: 'services.Vehicles.fuelLevelNotAvailable' };
    }

    return null;
  },
};

export class _ConnectedFuelField extends PureComponent {
  static defaultProps = {
    disabled: false,
    readOnly: false,
    touched: false,
  };

  onChange = (event) => {
    if (event.persist) {
      event.persist();
    }

    const { value } = event.target;

    // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
    if (value !== this.props.value || !this.props.edited) {
      // @ts-expect-error TS(2339): Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
      this.props.onChange(event);
    }

    // @ts-expect-error TS(2339): Property 'edited' does not exist on type 'Readonly... Remove this comment to see the full error message
    if (!this.props.edited) {
      // @ts-expect-error TS(2339): Property 'setEdited' does not exist on type 'Reado... Remove this comment to see the full error message
      this.props.setEdited(this.props.name, true);
    }
    // @ts-expect-error TS(2339): Property 'setAutofillEditedValues' does not exist on type 'Reado... Remove this comment to see the full error message
    if (this.props.setAutofillEditedValues) {
      // @ts-expect-error TS(2339): Property 'setAutofillEditedValues' & 'name' does not exist on type 'Reado... Remove this comment to see the full error message
      this.props.setAutofillEditedValues(this.props.name, value);
    }
  };

  onClickRefresh = () => {
    // @ts-expect-error TS(2339): Property 'onClickRefresh' does not exist on type '... Remove this comment to see the full error message
    this.props.onClickRefresh(this.props.name, 'fuelLevel');
  };

  render() {
    const {
      // @ts-expect-error TS(2339): Property 'connectedMetadata' does not exist on typ... Remove this comment to see the full error message
      connectedMetadata = {},
      // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
      disabled,
      // @ts-expect-error TS(2339): Property 'edited' does not exist on type 'Readonly... Remove this comment to see the full error message
      edited,
      // @ts-expect-error TS(2339): Property 'error' does not exist on type 'Readonly<... Remove this comment to see the full error message
      error,
      // @ts-expect-error TS(2339): Property 'label' does not exist on type 'Readonly<... Remove this comment to see the full error message
      label,
      // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      name,
      // @ts-expect-error TS(2339): Property 'onClickRefresh' does not exist on type '... Remove this comment to see the full error message
      onClickRefresh,
      // @ts-expect-error TS(2339): Property 'readOnly' does not exist on type 'Readon... Remove this comment to see the full error message
      readOnly,
      // @ts-expect-error TS(2339): Property 'required' does not exist on type 'Readon... Remove this comment to see the full error message
      required,
      // @ts-expect-error TS(2339): Property 'setEdited' does not exist on type 'Reado... Remove this comment to see the full error message
      setEdited,
      // @ts-expect-error TS(2339): Property 'touched' does not exist on type 'Readonl... Remove this comment to see the full error message
      touched,
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      value,
      // @ts-expect-error TS(2339): Property 'validators' does not exist on type 'Read... Remove this comment to see the full error message
      validators,
      // @ts-expect-error TS(2339): Property 'setAutofillEditedValues' does not exist ... Remove this comment to see the full error message
      setAutofillEditedValues,
      ...rest
    } = this.props;

    const connectedFuelLevel = connectedMetadata.isConnected ? connectedMetadata.connectedFuelLevel : '';

    const resolvedValue = !isNilOrEmpty(value) || edited ? value : connectedFuelLevel;

    const fieldProps = {
      ...rest,
      disabled,
      name,
      readOnly,
      onChange: this.onChange,
      value: resolvedValue,
    };

    const connectedFieldProps = {
      name,
      label,
      readOnly,
      error,
      disabled,
      hasValue: !isNilOrEmpty(resolvedValue),
      isConnected: connectedMetadata.isConnected,
      isManuallyEdited: !isNilOrEmpty(value) || edited,
      isValid: config.getValidity(connectedMetadata),
      lastConnectedDate: connectedMetadata.connectedFuelLevelDate,
      onClickRefresh: this.onClickRefresh,
      statusText: config.getConnectivityStatusText(connectedMetadata),
    };

    return (
      <ConnectedField {...connectedFieldProps}>
        {/* @ts-expect-error TS(2769): No overload matches this call. */}
        <FuelSelect {...fieldProps} options={FUEL_LEVEL_VALUES_V2} />
      </ConnectedField>
    );
  }
}

const FormConnectedFuelField = withFormikInput(_ConnectedFuelField, {
  passProps: ['touched'],
  watchedProps: ['edited', 'connectedMetadata'],
});

export const FormFuelSelect = withFormikInput(withFormField(FuelSelect));

export default FormConnectedFuelField;
